
import { Props_SnippetIcons } from "./Icons.props";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import SharedHeading from "../Shared/Heading/Heading";


const SnippetIcons = (props: Props_SnippetIcons) => {
    const { heading, content, repeatable_entry } = props;
        const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';

    // Show innerContent for all entries, but only highlight/show on focus/hover for desktop
    return (
        <section className="snippet-icons">
            <div className={`snippet-icons__container`}>
                <div className="snippet-icons__container-content">
                    <SharedHeading
                        className="snippet-icons__heading"
                        alignment={
                            heading.alignment?.value === "start" ||
                            heading.alignment?.value === "center" ||
                            heading.alignment?.value === "end"
                                ? heading.alignment.value
                                : undefined
                        }
                        level={headingLevel}
                        visibility={
                            typeof heading.visibility?.value === "boolean"
                                ? heading.visibility.value
                                : heading.visibility?.value === "true"
                        }
                    >
                        {heading.text?.value}
                    </SharedHeading>
                    {content.content?.value && typeof content.content.value === 'string' && (
                        <div className="snippet-icons__content">
                            {CompileMarkdown(content.content.value)}
                        </div>
                    )}
                </div>
                <div className="snippet-icons__container-entries">
                    {repeatable_entry.map((entry, index: number) => {
                        const { image, alt, heading, innerContent } = entry;
                        return (
                            <div
                                key={index}
                                className={`snippet-icons__entry`}
                                aria-labelledby={`icons-entry-heading-${index}`}
                            >
                                <div className="snippet-icons__entry-outer-container">
                                    {image?.value && typeof image.value === 'string' && (
                                        <figure className="snippet-icons__entry-image-container">
                                            <img
                                                className="snippet-icons__entry-image"
                                                loading="lazy"
                                                height={120}
                                                width={120}
                                                src={image.value}
                                                alt={typeof alt?.value === 'string' ? alt.value : ""}
                                            />
                                        </figure>
                                    )}
                                    {heading?.value && typeof heading.value === 'string' && (
                                        <h3
                                            className="snippet-icons__entry-heading"
                                            id={`icons-entry-heading-${index}`}
                                        >
                                            {heading.value}
                                        </h3>
                                    )}
                                </div>
                                {innerContent?.value && typeof innerContent.value === 'string' && (
                                    <div
                                        className="snippet-icons__entry-inner-content"
                                        id={`icons-inner-content-${index}`}
                                    >
                                        {CompileMarkdown(innerContent.value)}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default SnippetIcons;
